import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

export const UserMessageTail: React.FC<SvgProps> = (props) => {
    return (
        <Svg width={15} height={19} viewBox="0 0 15 19" fill="none" {...props}>
            <Path
                d="M-8 0c.542 10.622 6.79 19 14.419 19 3.213 0 6.18-1.486 8.581-4h-.119C8.241 15 2.646 8.65.951 0z"
                fill="#DEF8D5"
            />
        </Svg>
    );
};

export default React.memo(UserMessageTail);
